import React from 'react';
import { WhiteLabelLandingTemplate, CountryConfig } from './WhiteLabelLandingTemplate';

const ukConfig: CountryConfig = {
  country: 'UK',
  currencySymbol: '£',
  prices: {
    basic:   '£2,000',
    prime:   '£4,000',
    elite:   '£6,000',
    supreme: '£8,000'
  },
  costComparison: [
    { role: 'Media Buyer',     cost: '£48k – £72k yearly' },
    { role: 'SEO Specialist',  cost: '£44k – £64k yearly' },
    { role: 'Designer',        cost: '£40k – £56k yearly' }
  ],
  timezoneQuestion: 'Do you support UK timezone?',
  timezoneAnswer: 'Yes. Timezone alignment is available for agencies that require it.',
  agencyLabel: 'UK Agency Partnership Lead',
  thankYouPath: '/whitelabeluk/thank-you',
  phonePlaceholder: '+44 (0)20 0000 0000',
  cityPlaceholder: 'London, UK',
  testimonials: [
    {
      quote: 'Their white-label execution has helped us scale client delivery without increasing payroll pressure.',
      author: 'Agency Owner, London',
      result: 'Scaled from 22 to 48 active projects in 6 months'
    },
    {
      quote: 'Fast turnaround, transparent reporting, and strong campaign outcomes. Our clients are happier than ever.',
      author: 'Growth Director, Manchester',
      result: 'Improved retention and reduced campaign delays by 40%'
    },
    {
      quote: 'They work exactly like an in-house team under our brand. Communication and quality are consistently strong.',
      author: 'Founder, Birmingham',
      result: 'Increased margins while expanding service capacity'
    }
  ],
  docTitle: 'White Label Digital Marketing Execution for UK Agencies | Mirani Marketing',
  docDescription: 'Scale your digital marketing agency without hiring more staff. Dedicated execution team delivering SEO, AI-SEO, Google Ads, Meta Ads, Creative Production, and Video Editing under your agency brand — built for UK agencies.'
};

export const UKLandingPage: React.FC = () => <WhiteLabelLandingTemplate config={ukConfig} />;
export default UKLandingPage;
